import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { InsightsCardSkeleton } from './InsightsCardSkeleton';

import { Card, ChangeIndicator } from '../../atoms';
import { CardContent } from '../../atoms/Card/Card';
import { Tag, TagProps } from '../../atoms/Tag/Tag';

export type InsightsCardProps = {
  title: string;
  value: number;
  changeValue: number;
  responsesValue: number;
  label: TagProps;
  isLoading?: boolean;
  showComparedToAverage?: boolean;
};

export const InsightsCard: FC<InsightsCardProps> = ({
  title,
  value,
  changeValue,
  responsesValue,
  label,
  isLoading,
  showComparedToAverage = true,
}) => {
  const { t } = useTranslation('components');

  if (isLoading) {
    return <InsightsCardSkeleton />;
  }

  return (
    <Card className="rounded-[12px] min-h-[104px] flex flex-col p-4">
      <CardContent className="h-full grow flex flex-col">
        <div className="flex justify-between items-start gap-3 mb-[14px] grow">
          <div className="max-w-[340px]">
            <p className="text-body-14-semibold text-custom-warm-grey-800">{title}</p>
          </div>
          <div className="flex items-center gap-1">
            <p className="text-body-14-semibold text-custom-warm-grey-800">{value}%</p>
            {showComparedToAverage ? <ChangeIndicator changeValue={changeValue} /> : null}
          </div>
        </div>
        <div className="flex justify-between  gap-3">
          <div className="flex items-center flex-wrap gap-2">
            <Tag {...label} />
          </div>
          <div>
            <p className="text-body-14-regular text-custom-warm-grey-500">
              {t('insightsCard.responseCount', { responseCount: responsesValue })}
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
